import React, { useEffect, useState } from "react";
import { GridColDef } from "@mui/x-data-grid";
import DynamicDataGridTemplate from "./DynamicDataGridTemplate";
import DynamicDialogTemplate from "./DynamicDialogTemplate";
import ConfirmDeleteDialog from "./ConfirmDeleteDialog";

interface Props<T> {
  columns: GridColDef[];
  data: T[];
  loading: boolean;
  selectedRow?: T;
  FormComponent?: React.ReactNode;
  entityLabel?: string;
  dialogTitle: string;
  onClearSelectedRow?: () => void;
  onConfirmDelete: (data?: T | null) => void;
  entityToDelete: T | any;
}
// DynamicTableListTemplate Component
// A generic and dynamic component to render a table list.
// It accepts columns, data, and other props to customize the appearance and behavior of the table.

export const DynamicTableListTemplate = <T,>({
  columns,
  data,
  loading,
  selectedRow,
  FormComponent,
  entityLabel,
  dialogTitle,
  onClearSelectedRow,
  onConfirmDelete,
  entityToDelete,
}: Props<T>) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isConfirmDialogOpen, setIsConifrmDialogOpen] = useState(false);

  useEffect(() => {
    setIsDialogOpen(!!selectedRow);

    setIsConifrmDialogOpen(!!entityToDelete);
  }, [selectedRow, entityToDelete]);

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
    onClearSelectedRow?.();
  };

  return (
    <div>
      <DynamicDataGridTemplate
        columns={columns}
        rows={data}
        loading={loading}
        onAdd={() => setIsDialogOpen(true)}
        entityLabel={entityLabel}
      />
      <DynamicDialogTemplate
        isOpen={isDialogOpen}
        title={dialogTitle}
        onClose={handleCloseDialog}
      >
        {FormComponent}
      </DynamicDialogTemplate>

      <ConfirmDeleteDialog
        open={isConfirmDialogOpen}
        onClose={() => {
          setIsConifrmDialogOpen(false);
          onConfirmDelete(null);
        }}
        onConfirm={() => {
          onConfirmDelete(entityToDelete);
          setIsConifrmDialogOpen(false);
        }}
        entityName={(entityToDelete && entityToDelete?.email) || entityLabel}
        confirmationText="delete"
        title={`Remove ${entityLabel}`}
        description={"Are you sure you want to remove this " + entityLabel}
      />
    </div>
  );
};
